import axios from 'axios';
import { BASE_URL } from '../constants/urls';

// Envio de e-mails (reset de senha e formulários) pelo backend principal.
// O timeout garante que o usuário sempre receba um retorno, mesmo se o servidor não responder.
export const postEmail = (path, data) =>
  axios.post(`${BASE_URL}${path}`, data, {
    timeout: 15000,
    headers: { Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}` },
  });

// Prioriza a mensagem do backend (a validação devolve uma lista de mensagens)
export const getApiErrorMessage = (err, fallback) => {
  if (err?.response?.status === 429) {
    return 'Muitas tentativas. Aguarde alguns minutos e tente novamente.';
  }

  // Tempo esgotado ou sem resposta do servidor (rede, CORS, servidor fora do ar)
  if (err?.code === 'ECONNABORTED' || !err?.response) {
    return 'Não foi possível conectar. Tente novamente em instantes.';
  }

  const message = err.response.data?.message;
  if (Array.isArray(message)) return message[0] || fallback;
  return message || fallback;
};
